import {
  Input,SimpleChanges,OnChanges,
  ViewChild,
  Component,
  OnInit,Inject
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {MatDialogModule} from '@angular/material';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import {TranslateService} from "../../../../../node_modules/ng2-translate/src/translate.service";
import {AlertService} from "../../../services/alert/alert.service";
import {SessionDateVM} from "../../../models/SessionDateVM.model";
// import {DateUtilService} from "../../services/date-service/DateUtilService";
import {PersonService} from "../../../services/person/person-service";
import {DateUtilService} from "../../../services/date-service/DateUtilService";


/**
 * A Sample of how simple it is to create a new window, with its own injects.
 */
@Component({
  selector: 'rw-select-date-dialog-v2',
  providers: [
    DateUtilService
  ],
  template: require('./select-date-dialog-v2.template.html'),
  styles: [require('./select-date-dialog.style.css')]
})
export class SelectDateDialogV2 {

  public textToCopy:string;
  public activeDays:SessionDateVM[];
  public selectedDate:Date;
  public currentSelectedDate:Date;


  constructor(public dialogRef:MatDialogRef<SelectDateDialogV2>,
              @Inject(MAT_DIALOG_DATA) public data:any,
              public route:ActivatedRoute,
              public alertService:AlertService,
              public router:Router,
              public dialog:MatDialog,
              private translate:TranslateService) {
    this.activeDays = data.activeDays;

    data.test='test value';


  }
  selectedDateChanged(event)
  {
    this.data.selectedDate=event;
  }

  onConfirm()
  {
    this.data.selectedDate=this.currentSelectedDate;

    this.dialogRef.close();
  }
  onClose()
  {

    this.dialogRef.close();
  }


}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/component/shared/select-date-dialog/select-date-dialog-v2.component.ts